var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-p-c-list',{attrs:{"getParams":_vm.getParams,"id":"VpcListForCloudregionSidePage","hidden-actions":['create'],"hidden-filter-options":['brand', 'region', 'cloudaccount']}})
}
var staticRenderFns = []

export { render, staticRenderFns }